import { faFilter, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import { formatDate } from 'helpers/formatDate';
import { scrollDate } from 'helpers/scrollDate';
import { DatePicker } from 'components/DatePicker';
import { Checkbox } from 'components/Checkbox';
import { Dropdown } from 'components/Dropdown';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import styles from './Header.scss';

export const Header = ({ handleCreatePayment, filters, setFilters }) => {
  const [localFilters, setLocalFilters] = useState({ paid: null, type: null, date: formatDate(new Date()) });
  const [isDateEnabled, setIsDateEnabled] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const handleDateChange = useCallback(
    (direction) => setLocalFilters((prev) => ({ ...prev, date: scrollDate(prev.date, direction) })),
    [setLocalFilters]
  );

  const handleFilterChange = useCallback((field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  }, []);

  useEffect(() => {
    handleFilterChange('date', isDateEnabled ? localFilters.date || '' : '');
    handleFilterChange('paid', localFilters.paid?.value || '');

    if (localFilters.type?.value === 'subscription') {
      handleFilterChange('subscriptionID', 'not_empty');
      handleFilterChange('entryID', '');
    } else if (localFilters.type?.value === 'entry') {
      handleFilterChange('entryID', 'not_empty');
      handleFilterChange('subscriptionID', '');
    } else {
      handleFilterChange('subscriptionID', '');
      handleFilterChange('entryID', '');
    }
  }, [localFilters, isDateEnabled]);

  return (
    <div className={styles.controls}>
      <div className={styles.searchSection}>
        <Input
          className={styles.searchInput}
          icon={faSearch}
          placeholder='Пошук по призначенню, сумі...'
          value={filters.search}
          onChange={(e) => handleFilterChange('search', e.target.value)}
        />
        <Button
          className={cn(styles.filterButton, { [styles.active]: showFilters })}
          onClick={() => setShowFilters(!showFilters)}
          noStyle
        >
          <FontAwesomeIcon icon={faFilter} />
        </Button>
        <Button className={styles.createButton} onClick={handleCreatePayment} smallStyle>
          <FontAwesomeIcon icon={faPlus} />
          Створити рахунок
        </Button>
      </div>

      {showFilters && (
        <div className={styles.filtersPanel}>
          <div className={styles.filterRow}>
            <div className={styles.filterGroup}>
              <label className={styles.label}>Статус оплати</label>
              <Dropdown
                className={styles.dropdown}
                placeholder='Оберіть статус'
                value={localFilters.paid}
                options={[
                  { label: 'Оплачено', value: 'true' },
                  { label: 'Не оплачено', value: 'false' },
                ]}
                onChange={(option) => setLocalFilters((prev) => ({ ...prev, paid: option }))}
              />
            </div>
            <div className={styles.filterGroup}>
              <label className={styles.label}>Тип рахунку</label>
              <Dropdown
                className={styles.dropdown}
                placeholder='Оберіть тип'
                value={localFilters.type}
                options={[
                  { label: 'Пакети', value: 'subscription' },
                  { label: 'Заняття', value: 'entry' },
                ]}
                onChange={(option) => setLocalFilters((prev) => ({ ...prev, type: option }))}
              />
            </div>
            <div className={styles.filterGroup}>
              <Checkbox
                className={styles.label}
                checked={isDateEnabled}
                onChange={() => setIsDateEnabled((prev) => !prev)}
                label='Дата створення'
              />
              <DatePicker
                className={cn(styles.datePicker, { [styles.hidden]: !isDateEnabled })}
                date={localFilters.date}
                handleScrollDate={handleDateChange}
                enableCalendar
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
